import React from 'react';
import { useTranslation } from '../../../common/components/LocalizationProvider';
import { formatTime } from '../../../common/util/formatter';

/**
 * PrintFooter - Rodapé para relatórios (aparece em todas as páginas)
 *
 * Características:
 * - Posição fixa no bottom via CSS @media print
 * - Mostra em todas as páginas automaticamente
 * - Número da página via CSS counter
 *
 * @param {Object} props
 * @param {string} [props.companyName] - Nome da empresa
 * @param {string} [props.phone] - Telefone
 * @param {string} [props.email] - Email
 * @param {string} [props.generatedBy] - Usuário que gerou
 */
const PrintFooter = ({
  companyName,
  phone,
  email,
  generatedBy,
}) => {
  const t = useTranslation();
  const generatedAt = formatTime(new Date(), 'minutes');

  return (
    <footer className="print-footer">
      {/* Esquerda: Info da empresa */}
      <div className="print-footer__left">
        <span>{companyName}</span>
        {phone && <span> | {phone}</span>}
        {email && <span> | {email}</span>}
      </div>

      {/* Centro: Número da página */}
      <div className="print-footer__center">
        <span className="print-footer__page">{t('sharedPage')} </span>
      </div>

      {/* Direita: Data de geração */}
      <div className="print-footer__right">
        <span>{t('reportGeneratedAt') || 'Gerado em'}: {generatedAt}</span>
        {generatedBy && <span> | {generatedBy}</span>}
      </div>
    </footer>
  );
};

export default PrintFooter;
